import { isSSR } from "@shared/utils/fullscriptEnv/fullscriptEnv";

const getStorageData = (storage: Storage, key: string): any => {
  let data: string | null;

  try {
    data = storage.getItem(key);
  } catch {
    return null;
  }

  if (data === null) return null;

  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};

const setStorageItem = (storage: Storage, key: string, data: any): boolean => {
  try {
    storage.setItem(key, data);

    return true;
  } catch {
    return false;
  }
};

const setStorageData = (storage: Storage, key: string, data: any): void => {
  let serializedData: any;

  try {
    serializedData = JSON.stringify(data);
  } catch {
    setStorageItem(storage, key, data);

    return;
  }

  if (!setStorageItem(storage, key, serializedData)) {
    setStorageItem(storage, key, data);
  }
};

const removeStorageData = (storage: Storage, key: string): void => {
  try {
    storage.removeItem(key);
  } catch {
    // Storage can be present but inaccessible when browser privacy settings block it.
  }
};

export const getLocalData = (key: string): any => {
  if (isSSR() || typeof localStorage === "undefined" || !localStorage) return null;

  return getStorageData(localStorage, key);
};

export const setLocalData = (key: string, data: any): void => {
  if (isSSR() || typeof localStorage === "undefined" || !localStorage) return;

  setStorageData(localStorage, key, data);
};

export const removeLocalData = (key: string): void => {
  if (isSSR() || typeof localStorage === "undefined" || !localStorage) return;

  removeStorageData(localStorage, key);
};

export const getSessionData = (key: string): any => {
  if (isSSR() || typeof sessionStorage === "undefined" || !sessionStorage) return null;

  return getStorageData(sessionStorage, key);
};

export const setSessionData = (key: string, data: any): void => {
  if (isSSR() || typeof sessionStorage === "undefined" || !sessionStorage) return;

  setStorageData(sessionStorage, key, data);
};

export const removeSessionData = (key: string): void => {
  if (isSSR() || typeof sessionStorage === "undefined" || !sessionStorage) return;

  removeStorageData(sessionStorage, key);
};
